import { render, staticRenderFns } from "./CommercialInvoice.vue?vue&type=template&id=164adb75"
import script from "./CommercialInvoice.vue?vue&type=script&lang=js"
export * from "./CommercialInvoice.vue?vue&type=script&lang=js"
import style0 from "./CommercialInvoice.vue?vue&type=style&index=0&id=164adb75&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports